import { PersonRequest } from "@plinknz/tah-website-elements";

import { bankConfig } from "./config-generics/bank-details";
import { personalDetailsConfig } from "./config-generics/personal-details";
import { signatureConfig } from "./config-generics/signature";
import { DATEPICKER_KEY } from "../../components/survey-widgets/datepicker-widget";
import { SurveyConfig } from "../../components/content-blocks/forms/customer-form-types";

export const createSurveyConfig = (member: PersonRequest): SurveyConfig => {
  const personalConfig = personalDetailsConfig(member);

  return {
    pages: [
      {
        name: "guidelines",
        title: "Guidelines - Aratohu",
        elements: [
          {
            type: "html",
            html: `
<p>
  Cultural and sporting pursuits are an important aspect
  of personal, whānau, hapū and iwi development. For this
  purpose, Rangitāne allocates a limited amount of
  funding toward sponsorship each year.
</p>
<p>
  The purpose of Pūtea Tautoko is to encourage and
  recognise the pursuit of cultural and sporting excellence
  by Rangitāne.
</p>
<p>
  Sponsorship may be allocated to participants or events
  promoting Rangitāne o Wairau in culture and sports in a
  regional/national or international forum.
</p>
<p>
  Applicants can apply more than once per financial year
  (1 July – 30 June) however the maximum per year is
  $500.00. Applications will be considered monthly (pending
  number of applications). On occasion, the event may take
  place before the meeting is held. If for any reason the
  event does not take place or the applicant is unable to
  attend the grant must be refunded in full.
</p>
          `,
          },
        ],
      },
      ...personalConfig,
      ...bankConfig,
      {
        name: "event",
        title: "Event - Kaupapa",
        questions: [
          {
            type: "text",
            name: "event",
            title:
              "What is the name of the event you are seeking sponsorship for?",
            placeHolder: "Kaupapa",
            isRequired: true,
          },
          {
            type: "comment",
            name: "purpose",
            title: "What is its purpose?",
            placeHolder: "Aronga",
            isRequired: true,
          },
          {
            type: DATEPICKER_KEY,
            inputType: "date",
            name: "date",
            title: "What date is it?",
            isRequired: true,
          },
          {
            type: "text",
            name: "attendees",
            title: "How many people are coming?",
            placeHolder: "Kaupapa",
            startWithNewLine: false,
          },
        ],
      },
      {
        name: "funding",
        title: "Funding Information - Taipitopito Pūtea",
        questions: [
          {
            type: "text",
            name: "amount",
            placeHolder: "Pūtea",
            title: "Total amount requested",
            isRequired: true,
          },
          {
            type: "file",
            name: "budget",
            title: "Please upload an itemised budget",
            storeDataAsText: false,
            allowMultiple: false,
            maxSize: 10485760,
            waitForUpload: true,
            startWithNewLine: true,
            isRequired: true,
          },
          {
            type: "text",
            name: "arongaPutea",
            placeHolder: "Aronga pūtea",
            title: "What is the main purpose of the sponsorship funding?",
            startWithNewLine: true,
            isRequired: true,
          },
        ],
      },
      {
        name: "rangitane",
        title:
          "How will you represent Rangitāne - Mahi hei kanohi o Rangitāne?",
        questions: [
          {
            type: "comment",
            name: "representRangitane",
            placeHolder: "Kanohi Rangitāne",
            title:
              "Give a brief description of how you expect to represent Rangitāne?",
            isRequired: true,
          },
          {
            type: "comment",
            name: "benefitRangitane",
            placeHolder: "Ngā hua",
            title: "How will the project benefit Rangitāne?",
            isRequired: true,
          },
          {
            type: "comment",
            name: "acknowledgement",
            placeHolder: "Eg: banners on site",
            title: "How will you acknowledge Rangitāne if you are successful?",
            isRequired: true,
          },
        ],
      },
      {
        name: "attachments",
        title: "Attachments - Whakapiringa",
        questions: [
          {
            type: "file",
            name: "promotionalMaterial",
            title:
              "If appropriate please upload promotional material that will be used",
            storeDataAsText: false,
            allowMultiple: false,
            maxSize: 10485760,
            waitForUpload: true,
            startWithNewLine: true,
            isRequired: false,
          },
          {
            type: "file",
            name: "associateLetter",
            title:
              "If appropriate please upload a letter on the associates letterhead that confirms I have been selected to participate as an individual in a regional, national or international event",
            storeDataAsText: false,
            allowMultiple: false,
            maxSize: 10485760,
            waitForUpload: true,
            startWithNewLine: true,
            isRequired: false,
          },
        ],
      },
      ...signatureConfig,
      {
        name: "process",
        title: "Timelines - Wataka",
        elements: [
          {
            type: "html",
            html: `
  <p>From here the process is:</p>
  <p><ul>
    <li>Your application will be compared to the criteria</li>
    <li>A recommendation will be submitted to the Pūtea Tautoko kete for approval</li>
    <li>A letter will be sent back to you with the outcome</li>
    <li>All payments are made on the 20th of the month prior to the event where possible</li>
  </ul></p>
  <p>All Enquiries Phone <a href="tel:+6435786180">03 578 6180</a>.</p>
          `,
          },
        ],
      },
    ],
  };
};
